import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Footer from "../../components/Footer/Footer";
import Loader from "../../components/loader/Loader";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

// Images
import InformationIcon1 from "../../assets/images/information-icons/information-icon1.png";
import InformationIcon2 from "../../assets/images/information-icons/information-icon2.png";
import InformationIcon3 from "../../assets/images/information-icons/information-icon3.png";
import InformationIcon4 from "../../assets/images/information-icons/information-icon4.png";
import InformationIcon5 from "../../assets/images/information-icons/information-icon5.png";
import InformationIcon6 from "../../assets/images/information-icons/information-icon6.png";
import BackgroundTools from "../../assets/images/tools.jpg";

import { publicArea } from "../../../Routes.js";

import Slide from "@material-ui/core/Slide";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	paper: {
		position: "absolute",
		width: 450,
		backgroundColor: theme.palette.background.paper,
		boxShadow: theme.shadows[5],
		padding: theme.spacing(4, 4, 4),
	},
}));

function Third(props) {
	const [hide, setHide] = useState("block");
	const [hide1, setHide1] = useState("none");

	// Similar ao componentDidMount e componentDidUpdate:
	useEffect(() => {
		publicArea();
		const elements = document.getElementsByClassName("loader-ring");
		for (var i = 0; i < elements.length; i++) {
			elements[i].style.borderColor =
				"#2e2b84 transparent transparent transparent";
		}
	}, []);

	function loadAfterImage() {
		setTimeout(function () {
			var img = new Image();
			img.onload = function () {
				setHide("none");
				setHide1("block");
			};
			img.src = BackgroundTools;
		}, 1);
	}

	function ShowWindowDimensions(props) {
		const [width, height] = [window.innerWidth, window.innerHeight];

		var windowHeight = "";
		var paddingTop = "";

		if (width > 991) {
			windowHeight = height - 112 + "px";
		} else {
			windowHeight = height - 56 + "px";
		}

		if (props === "padding") {
			const heightStyle = {
				paddingTop: paddingTop,
			};

			return heightStyle;
		}

		const heightStyle = {
			height: windowHeight,
		};

		return heightStyle;
	}

	useStyles();

	return (
		<>
			<div style={{ display: hide }}>
				<Loader />
			</div>
			<Slide
				direction="left"
				in={true}
				style={{ display: hide1 }}
				mountOnEnter
				unmountOnExit
			>
				<section className="contact-page">
					<div
						id={"background-image"}
						className="contact-banner"
						style={ShowWindowDimensions()}
					>
						<div className="banner-links" onLoad={loadAfterImage()}>
							<h1>Conectamos você aos clientes!</h1>
						</div>
						<div className={"more-info-container--same-side"}>
							<span className={"more-info-text"}>Saiba mais</span>
							<ExpandMoreIcon />
						</div>
					</div>
					<div className="more-information">
						<div className="pro-information">
							<h2
								className={"remove-padding-top structure-title"}
							>
								Com a <b>MMS</b> você pode mais!
							</h2>
							<div className="pro-information-icons">
								<div className="information-icon">
									<img alt="" src={InformationIcon1}></img>
									<p>
										Você precisa ter uma
										<br />
										empresa aberta, com CNPJ,
										<br /> e emitir nota fiscal.
									</p>
								</div>
								<div className="information-icon">
									<img alt="" src={InformationIcon2}></img>
									<p>
										Tenha serviço o ano inteiro!
										<br />
										São mais de 1 milhão de serviços
										<br />
										ao ano, em todo o país!
									</p>
								</div>
								<div className="information-icon">
									<img alt="" src={InformationIcon3}></img>
									<p>
										Liberdade de agenda!
										<br />
										Você escolhe os períodos e
										<br />
										regiões onde deseja trabalhar.
									</p>
								</div>
								<div className="information-icon">
									<img alt="" src={InformationIcon4}></img>
									<p>
										Aumente a sua renda de
										<br />
										acordo com o rendimento
										<br />
										do seu tempo.
									</p>
								</div>
								<div className="hide-box information-icon" />
								<div className="information-icon">
									<img alt="" src={InformationIcon5}></img>
									<p>
										Receba a cada
										<br />
										15 dias.
									</p>
								</div>
								<div className="information-icon">
									<img alt="" src={InformationIcon6}></img>
									<p>
										Central de
										<br />
										Atendimento Exclusiva.
									</p>
								</div>
							</div>
						</div>
					</div>
					<Footer />
				</section>
			</Slide>
		</>
	);
}

export default Third;
